import * as React from "react";
const SvgProfileUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#profileUser_svg__a)">
      <path
        stroke="#89909D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M16.092 4.817a3.18 3.18 0 0 1 3.18 3.18 3.185 3.185 0 0 1-3.062 3.18 1 1 0 0 0-.237 0m1.872 8.178a4.4 4.4 0 0 0 1.781-.79c1.418-1.063 1.418-2.817 0-3.88-.5-.382-1.109-.636-1.754-.781M9.504 11.06c-.091-.01-.2-.01-.3 0a4.016 4.016 0 0 1-3.88-4.026C5.324 4.808 7.124 3 9.358 3a4.03 4.03 0 0 1 .145 8.06M4.96 14.412c-2.2 1.472-2.2 3.871 0 5.334 2.498 1.672 6.596 1.672 9.095 0 2.199-1.472 2.199-3.87 0-5.334-2.49-1.662-6.587-1.662-9.095 0"
      />
    </g>
    <defs>
      <clipPath id="profileUser_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgProfileUser;
